/**
 * Public careers page, hosted in Webflow.
 *
 * This SPA used to serve its own public careers page at "/", but that page was
 * a duplicate of the Webflow one and has been sunset - "/" now serves the
 * protected internal job board. Anything that sends a user "back" to the
 * public careers experience should point here.
 *
 * Kept in one place because this URL has been mistyped before (a dropped
 * "www." subdomain), and it is referenced from several components.
 */
export const PUBLIC_CAREERS_URL = "https://www.periscope365.com/careers";
